// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseComponent } from '../../../../../com/MetaPattern/MDA/MD/Base/BaseComponent';
import { MenuSet } from './MenuSet';
import { ConfigGroup } from './ConfigGroup';
import { Task } from './Task';
import { Dependency } from './Dependency';
import { MenuContain } from './MenuContain';
import { TaskSequence } from './TaskSequence';
import { APPComment } from './APPComment';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { APPComponentExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/APPModel/APPComponentExtend';
/**
 * 应用模型组件 实体类
 * 应用模型组件，定义应用模型
 */
export class APPComponent extends BaseComponent {
  /** 菜单集 */
  private _menuSets: Array<MenuSet>;

  /** 获取：菜单集 */
  public get menuSets() {
    return this._menuSets;
  }

  /** 设置：菜单集 */
  public set menuSets(value: Array<MenuSet>) {
    this._menuSets = value;
  }

  /** 配置组 */
  private _configGroups: Array<ConfigGroup>;

  /** 获取：配置组 */
  public get configGroups() {
    return this._configGroups;
  }

  /** 设置：配置组 */
  public set configGroups(value: Array<ConfigGroup>) {
    this._configGroups = value;
  }

  /** 任务 */
  private _tasks: Array<Task>;

  /** 获取：任务 */
  public get tasks() {
    return this._tasks;
  }

  /** 设置：任务 */
  public set tasks(value: Array<Task>) {
    this._tasks = value;
  }

  /** 依赖包 */
  private _dependencies: Array<Dependency>;

  /** 获取：依赖包 */
  public get dependencies() {
    return this._dependencies;
  }

  /** 设置：依赖包 */
  public set dependencies(value: Array<Dependency>) {
    this._dependencies = value;
  }

  /** 菜单主子关系 */
  private _menuContains: Array<MenuContain>;

  /** 获取：菜单主子关系 */
  public get menuContains() {
    return this._menuContains;
  }

  /** 设置：菜单主子关系 */
  public set menuContains(value: Array<MenuContain>) {
    this._menuContains = value;
  }

  /** 任务顺序关系 */
  private _taskSequences: Array<TaskSequence>;

  /** 获取：任务顺序关系 */
  public get taskSequences() {
    return this._taskSequences;
  }

  /** 设置：任务顺序关系 */
  public set taskSequences(value: Array<TaskSequence>) {
    this._taskSequences = value;
  }

  /** 注释 */
  private _comments: Array<APPComment>;

  /** 获取：注释 */
  public get comments() {
    return this._comments;
  }

  /** 设置：注释 */
  public set comments(value: Array<APPComment>) {
    this._comments = value;
  }

  constructor() {
    super();
    APPComponentExtend.Init(this);
    this._menuSets = new Array<MenuSet>();
    this._configGroups = new Array<ConfigGroup>();
    this._tasks = new Array<Task>();
    this._dependencies = new Array<Dependency>();
    this._menuContains = new Array<MenuContain>();
    this._taskSequences = new Array<TaskSequence>();
    this._comments = new Array<APPComment>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: APPComponent, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    if (json.MenuSets && json.MenuSets.length > 0) {
      json.MenuSets.forEach((element: any) => {
        const menuSet = MenuSet.Create(element);
        // menuSet.component = this;
        this.menuSets.push(menuSet);
      });
    }
    if (json.ConfigGroups && json.ConfigGroups.length > 0) {
      json.ConfigGroups.forEach((element: any) => {
        const configGroup = ConfigGroup.Create(element);
        // configGroup.component = this;
        this.configGroups.push(configGroup);
      });
    }
    if (json.Tasks && json.Tasks.length > 0) {
      json.Tasks.forEach((element: any) => {
        const task = Task.Create(element);
        // task.component = this;
        this.tasks.push(task);
      });
    }
    if (json.Dependencies && json.Dependencies.length > 0) {
      json.Dependencies.forEach((element: any) => {
        const dependency = Dependency.Create(element);
        // dependency.component = this;
        this.dependencies.push(dependency);
      });
    }
    if (json.MenuContains && json.MenuContains.length > 0) {
      json.MenuContains.forEach((element: any) => {
        const menuContain = MenuContain.Create(element);
        // menuContain.aPPComponent = this;
        this.menuContains.push(menuContain);
      });
    }
    if (json.TaskSequences && json.TaskSequences.length > 0) {
      json.TaskSequences.forEach((element: any) => {
        const taskSequence = TaskSequence.Create(element);
        // taskSequence.aPPComponent = this;
        this.taskSequences.push(taskSequence);
      });
    }
    if (json.Comments && json.Comments.length > 0) {
      json.Comments.forEach((element: any) => {
        const aPPComment = APPComment.Create(element);
        // aPPComment.component = this;
        this.comments.push(aPPComment);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    if (this.menuSets && this.menuSets.length > 0) {
      json.MenuSets = [];
      this.menuSets.forEach((element) => {
        json.MenuSets.push(element.toJson());
      });
    }
    if (this.configGroups && this.configGroups.length > 0) {
      json.ConfigGroups = [];
      this.configGroups.forEach((element) => {
        json.ConfigGroups.push(element.toJson());
      });
    }
    if (this.tasks && this.tasks.length > 0) {
      json.Tasks = [];
      this.tasks.forEach((element) => {
        json.Tasks.push(element.toJson());
      });
    }
    if (this.dependencies && this.dependencies.length > 0) {
      json.Dependencies = [];
      this.dependencies.forEach((element) => {
        json.Dependencies.push(element.toJson());
      });
    }
    if (this.menuContains && this.menuContains.length > 0) {
      json.MenuContains = [];
      this.menuContains.forEach((element) => {
        json.MenuContains.push(element.toJson());
      });
    }
    if (this.taskSequences && this.taskSequences.length > 0) {
      json.TaskSequences = [];
      this.taskSequences.forEach((element) => {
        json.TaskSequences.push(element.toJson());
      });
    }
    if (this.comments && this.comments.length > 0) {
      json.Comments = [];
      this.comments.forEach((element) => {
        json.Comments.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): APPComponent {
    const aPPComponent = new APPComponent();
    aPPComponent.Deserialize(json);
    aPPComponent.json = json;
    return aPPComponent;
  }
}
